import * as requestFromServer from "./transactionsReportCrud";
import { callTypes, transactionsReportSlice } from "./transactionsReportSlice";

const { actions } = transactionsReportSlice;

export const fetchTransactionsReportList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .transactionsReportList({ queryParams })
    .then((response) => {
      const { count: totalCount, data: entities, Error } = response || {};
      if (Error) {
        console.log("Error", Error);
        dispatch(
          actions.catchError({ error: Error, callType: callTypes.list })
        );
      } else {
        dispatch(
          actions.transactionsReportListFetched({ totalCount, entities })
        );
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't find Transactions";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const exportTransactionsReportList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .transactionsReportListExport({ queryParams })
    .then((response) => {
      const { Error } = response || {};
      if (Error) {
        dispatch(
          actions.catchError({ error: Error, callType: callTypes.action })
        );
      } else {
        dispatch(
          actions.transactionsReportListExport({ xlsFilename: response })
        );
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't find Transactions";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const fetchTransactionsChartDetails = (queryParamsChart) => (
  dispatch
) => {
  dispatch(actions.startCall({ callType: callTypes.chart }));
  return requestFromServer
    .transactionsChartDetails({ queryParamsChart })
    .then((response) => {
      const { Error } = response || {};
      const { transactions, revenue } = response.response || {};
      if (Error) {
        dispatch(
          actions.catchError({ error: Error, callType: callTypes.chart })
        );
      } else {
        dispatch(
          actions.transactionsChartDetailsFetched({
            chartEntities: { transactions, revenue }
          })
        );
      }
    })
    .catch((error) => {
      error.clientMessage = "Can't find Transactions";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
